import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";


// import required modules
import { Autoplay } from "swiper";

import { Slide } from 'react-reveal';

const data = [
    {
        name: 'nayon das',
        title: 'student',
        profile: 'https://i.ibb.co/B2tB17B/bangladeshi-boys-beard-styles-bangladeshi-mens-hairstyle-photos-latest-bangladeshi-hairstyle.jpg',
        review: "মাইক্রোসফট এক্সেল কোর্সটি সত্যিই অসাধারণ। এর কোর্স কন্টেন্ট এর ধারাবাহিকতা একে এক অনন্য মাত্রা দিয়েছে। কোর্সের টেকনিকগুলো আমাকে স্টুডেন্ট-লাইফে ডাটা প্রসেসিং এ একধাপ এগিয়ে রেখেছে। আশাকরি এটি সবার জন্য ফলপ্রসূ হবে।"
    },
    {
        name: 'lata rani',
        title: 'student',
        profile: 'https://i.ibb.co/vhX2xGY/images.jpg',
        review: "করোনাকালে বাসায় বসে এডমিশন টেস্টের প্রস্তুতি নেওয়ার জন্য বাইরে গিয়ে গতানুগতিক কোনো কোচিং-এ ক্লাস করিনি আমি৷ ঈশ্বরের কৃপায় আমি আমার লক্ষ্যে পৌঁছাতে পেরেছি৷ আর এই লক্ষ্যে পৌঁছাতে সহায়ক হয়েছে রবি টেন মিনিট স্কুল ।"
    },
    {
        name: 'kamal pasha',
        title: 'engineer',
        profile: 'https://i.ibb.co/h8ThdQS/FRR-Zu-LVUAAd-w-K.jpg',
        review: "বিবিএ এর একজন ছাত্র হিসেবে প্রেজেন্টেশন বাধ্যতামূলক বিষয় এবং এর সাথে জড়িত মাইক্রোসফট পাওয়ারপয়েন্ট স্লাইড।এটি আমার জন্য একটি চ্যালেঞ্জিং বিষয় ছিল যা সহজ করতে সাহায্য করেছে টেন মিনিট স্কুলের পাওয়ারপয়েন্ট কোর্স। এই কোর্স শেষ করার মাধ্যমে আমি একটা সু"
    },
    {
        name: 'sujon ali',
        title: 'student',
        profile: 'https://i.ibb.co/T4nTR9M/2492181-611df4022da30.png',
        review: "আমি ১০মিনিট স্কুলের একজন নিয়মিত সদস্য।১০মিনিট স্কুল থেকে আমি অনেক কিছু শিখেছি যেটি আমার ব্যাক্তিগত এবং চাকুরি জীবনে সহায়তা করে। সব মিলিয়ে ১০মিনিট স্কুল একটি জ্ঞান আহরনের জায়গা।"
    },
    {
        name: 'tamanna khan',
        title: 'busiess',
        profile: 'https://i.ibb.co/hsX3THd/Zara-Jabeen-Mahbub.jpg',
        review: "১০ মিনিটস স্কুল থেকে মাইক্রোসফ্ট এক্সেল এর কোর্সটি করে আমি যথেষ্ট উপকৃত হয়েছি।আমি উক্ত কোর্স থেকে যা শিখেছি তা আমার কর্মক্ষেত্রে প্রতিনিয়ত কাজে লাগছে। ১০ মিনিটস স্কুল ভবিষ্যতে আরো নতুন নতুন যুগোপযগী কোর্স চালু করবে এই প্রত্যাশা করি। ধন্যবাদ ১০ মিনিটস"
    }
]

const Review = () => {
    return (
        <div>
            <div className='container-fluid p-5' style={{ marginTop: "80px" }}>
                <Slide left>
                    <div className="review-title text-center">
                        <h3 className='fw-bold fs-2'>সবার প্রথম পছন্দ</h3>
                        <p className='fs-4'>কেন আমরাই শিক্ষার্থী ও অভিভাবকগণের প্রথম পছন্দ?</p>
                    </div>
                </Slide>
                <div className="reviewCart">
                    <Swiper
                        slidesPerView={4}
                        spaceBetween={30}
                        loop={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            440: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            540: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            640: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 10,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                            },
                            1155: {
                                slidesPerView: 4,
                                spaceBetween: 10,
                            },
                        }}
                        modules={[Autoplay]}
                        className="mySwiper"
                    >

                        {
                            data.map(pd => {
                                return (
                                    <SwiperSlide>
                                        <div className="review-profile shadow-lg p-2 position-relative mb-5" style={{ height: '330px', marginTop: '100px', borderRadius: '15px 100px' }}>
                                            <div className="d-flex align-items-center mt-5">
                                                <div className="review-logo">
                                                    <img src={pd?.profile} alt="profile" className="img-fluid rounded-pill" style={{ height: '50px', width: '50px' }} />
                                                </div>
                                                <div className="review-title ps-2">
                                                    <h5 className="text-capitalize fw-bold fs-6"> {pd?.name}</h5>
                                                    <h5 className="text-capitalize text-secondary fs-6"> {pd?.title}</h5>
                                                </div>
                                            </div>
                                            <div className="review-commnet mt-3">
                                                <p className="text-secondary fs-5">{pd?.review?.length > 50 ? pd?.review?.slice(0, 150) : pd?.review}...</p>
                                            </div>
                                            <div className="logo5 position-absolute top-0 start-0">
                                                <img src="https://i.ibb.co/KL4vPSm/cote.webp" alt="logo" />
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )
                            })
                        }

                    </Swiper>

                </div>
            </div>
        </div >
    );
};

export default Review;